// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3vOFl","requiredAsterisk":"Info_requiredAsterisk__3dq-x"};